<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn
                    color="indigo"
                    class="white--text"
                    :to="{ name: 'product.create' }"
                >
                    <v-icon left>mdi-plus</v-icon>
                    {{
                        $t('resources.default.add', {
                            resource: $tc('resources.product.name', 1),
                        })
                    }}
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table">
                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    :to="{
                                        name: 'product.edit',
                                        params: { id: item.id },
                                    }"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('resources.default.edit') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="deleteItem(item)"
                                >
                                    <v-icon color="red" v-on="on"
                                        >mdi-close</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('resources.default.delete') }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>

        <confirm
            ref="confirmRemove"
            :confirmText="$t('dialogs-confirm.buttons.remove')"
            confirmColor="red darken-1"
        ></confirm>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Product from '@/models/product/Product'
import Confirm from '@/components/dialogs/Confirm'

export default {
    components: {
        SaralaTable,
        Confirm,
    },

    computed: {
        model() {
            return new Product()
        },
    },

    methods: {
        async deleteItem(model) {
            let confirm = await this.$refs.confirmRemove.open(
                this.$t('resources.dialogs.confirm.delete.title'),
                this.$t('resources.dialogs.confirm.delete.content', {
                    resource: this.$tc('resources.product.name', 1),
                    name: model.name,
                }),
            )

            if (!confirm) return

            let res = await model.delete()

            if (!res) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('resources.feedbacks.errors.delete', {
                        resource: this.$tc('resources.product.name', 1),
                    }),
                )
                return
            }

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.product.name', 1),
                }),
            )
        },
    },
}
</script>

<style></style>
